import { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useHostContext } from '@/context/HostContext';
import { partnerMetadata } from '@/services/PartnerMetadata';
import useAppStore from '@/store/app.ts';

const Metadata = () => {
	const { localization } = useHostContext();
	const industry = useAppStore((state) => state.customerData?.industry);

	const { metaTitle, metaOgTitle, metaOgDescription } = useMemo(() => {
		const resolvedIndustry =
			industry === 'restaurant_industry' ||
			industry === 'cleaning_service_industry'
				? industry
				: 'receptionist_industry';

		return {
			metaTitle: localization.translate(
				'creator',
				`industries.${resolvedIndustry}.metaTitle`
			),
			metaOgTitle: localization.translate(
				'creator',
				`industries.${resolvedIndustry}.metaOgTitle`
			),
			metaOgDescription: localization.translate(
				'creator',
				`industries.${resolvedIndustry}.metaOgDescription`
			)
		};
	}, [industry, localization]);

	if (!partnerMetadata.getFaviconUrl()) {
		console.error(
			'No favicon configured for partner:',
			partnerMetadata.getId()
		);
	}

	return (
		<Helmet>
			{partnerMetadata.getFaviconUrl() && (
				<link
					href={partnerMetadata.getFaviconUrl()}
					rel="icon"
					type="image/png"
				/>
			)}
			<title>
				{partnerMetadata.getName()}: {metaTitle}
			</title>
			<meta
				content={`${partnerMetadata.getName()}: ${metaOgTitle}`}
				property="og:title"
			/>
			<meta
				content={`${partnerMetadata.getName()}: ${metaOgDescription}`}
				property="og:description"
			/>
		</Helmet>
	);
};

export default Metadata;
